<template>
    <div class="data-overview">
        <div class="table-header">
            <span>{{ allFaq }}</span>
            <Button :text="exportText" :icon="addIcon" :hoverIcon="addIconHover" @btnClick="exportClick" />
        </div>
        <Table
            class="scene-table-list"
            :cur-page="curPage"
            :config="faqTableConfig"
            :dataset="tableData"
            :total="total"
            :showCheckedNum="true"
            @pageChange="pageChange"
            @sortChange="sortChange"
        />
    </div>
</template>

<script>
import Table from "@/views/zhiji/bComponents/newTable/Table.vue";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import { faqTableConfig } from "../pageConfig";
import { URLs } from "@/views/zhiji/js/common/constants.js";
import likeStatisticCvt from "@/views/zhiji/js/services/pageServices/likeStatisticCvt.js";

export default {
    components: {
        Table,
        Button,
    },
    data() {
        return {
            addIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -1px -116px",
            addIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -66px -115px"
        }
    },
    computed: {
        filter() {
            return this.getStorePorp("filter")
        },
        dates() {
            return this.getStorePorp("dates");
        },
        total() {
            return this.getStorePorp("faqTable").count;
        },
        curPage() {
            return this.getStorePorp("faqTable").page;
        },
        tableData() {
            return this.getStorePorp("faqTable").list;
        },
        allFaq() {
            return this.$t("zhiji.likedisplay.allFaq");
        },
        exportText() {
            return this.$t("zhiji.hotSpot.exportText");
        },
        faqTableConfig() {
            return faqTableConfig();
        },
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.likeDisplaySatis[propName];
        },
        exportClick() {
            const params = {
                ...this.filter,
                ...this.dates,
            };
            const reuqest = likeStatisticCvt.queryLikeStatistic2Server(params);
            const requestStr = Object.keys(reuqest).map(key => `${key}=${reuqest[key]}`).join('&');
            let reqUrl = URLs.EXPORT_LIKE_QUESTION + `?${requestStr}`;

            this.zhiji.requestByServiceName("getDownloadToken", reqUrl).then(result => {
                window.open(result, "_blank");
            });
        },
        pageChange(data) {
            this.$store.commit("zhiji/updateLikeFaqTable", {
                type: "page",
                data: data.curPage,
            });
            this.$store.dispatch("zhiji/queryLikeQuestion");
        },
        sortChange(data) {
            this.$store.commit("zhiji/resetLikePage");
            this.$store.dispatch("zhiji/queryLikeQuestion", {
                sortField: data.prop,
                sortType: data.order,
            });
        },
    }
}
</script>

<style lang="less" scoped>
.data-overview {
    background-color: #fff;
    border: 1px solid #d8e4f0;

    .table-header {
        padding: 6px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        >span {
            font-size: 14px;
            font-weight: bold;
        }
    }
}
</style>